<script lang="ts">
import { defineComponent, ref, reactive } from 'vue'
import backdrop from '@/models/backdrop'
import { useUserStore } from '@/stores/user'
import {
  mypagePath,
  editUserProfilesPath,
  staticPagesHelpPath,
  destroyUserSessionPath,
} from '@/generated/railsRoutes'

const BACKDROP_CANCEL_ID = 'user-navigation'

export default defineComponent({
  name: 'UserNavigationForHeader',

  setup() {
    // store
    const user = useUserStore()

    // model の backdrop の処理実体を定義
    backdrop(() => {
      isOpen.value = false
    }, BACKDROP_CANCEL_ID)

    const isOpen = ref(false)

    // @todo expo の URL 部分を、ページができ次第移行先の academy パスへ修正
    const navigation = reactive([
      {
        label: 'マイページ',
        to: mypagePath(),
      },
      {
        label: '設定',
        to: editUserProfilesPath(),
      },
      {
        label: 'ヘルプ',
        to: staticPagesHelpPath(),
      },
    ])

    const toggleNavigation = () => {
      isOpen.value = !isOpen.value
    }

    return {
      // constants
      BACKDROP_CANCEL_ID,

      // routes
      destroyUserSessionPath,

      // store
      user,

      // data
      isOpen,
      navigation,

      // methods
      toggleNavigation,
    }
  }
})
</script>

<template>
  <div
    :class="[
      'l-unit__userNavigationAction',
      { 'is-open': isOpen },
    ]"
    :data-backdrop-cancel="BACKDROP_CANCEL_ID">
    <div class="l-unit__userNavigationAction--description">
      <div class="o-list__userNavigation">
        <ul class="o-list__userNavigation--items">
          <li
            v-for="(item, index) in navigation"
            :key="index"
            class="o-list__userNavigation--item">
            <div class="o-action__userNavigation">
              <a
                class="o-action__userNavigation--item"
                :href="item.to">
                {{ item.label }}
              </a>
            <!-- /.o-action__userNavigation --></div>
          </li>
          <li class="o-list__userNavigation--item is-signout">
            <FormDefault
              :action="destroyUserSessionPath()"
              method="post"
              name="sign_out">
              <!--
                delete メソッドで Form submit する
                @see https://portaltan.hatenablog.com/entry/2015/07/22/122031
              -->
              <input
                class="input"
                type="hidden"
                name="_method"
                value="DELETE">
              <div class="o-action__userNavigation">
                <button
                  class="o-action__userNavigation--item"
                  type="submit">
                  ログアウト
                </button>
              <!-- /.o-action__userNavigation --></div>
            </FormDefault>
          </li>
        </ul>
      <!-- /.o-list__userNavigation --></div>
    <!-- /.l-unit__userNavigationAction description --></div>

    <div class="l-unit__userNavigationAction--action">
      <div class="o-action__userAvatar">
        <!--
          backdrop クリックイベントでメニューを閉じるアクションを発火させるため、
          container store で処理をする。
          ボタンクリックで container store のイベントを発火させないため、stop propagation を駆動させる。
        -->
        <button
          class="o-action__userAvatar--item"
          @click="toggleNavigation">
          <img
            v-if="user.context.thumbImageUrl"
            class="img"
            :src="user.context.thumbImageUrl"
            alt="">
        </button>
      <!-- /.o-action__userAvatar --></div>
    <!-- /.l-unit__userNavigationAction action --></div>
  <!-- /.l-unit__userNavigationAction --></div>
</template>

<style lang="sass" scoped>
// layout
.l-unit
  &__userNavigationAction
    $root: &
    position: relative

    & &--description
      width: 160px
      position: absolute
      top: #{$header-primary-height-pc}px
      right: 0
      transform: translateY(-18px)
      background-color: rgba($bg-white, 1)
      border: 1px solid $border-x-light-gray
      border-radius: $border-radius
      box-shadow: $box-shadow
      visibility: hidden
      opacity: 0
      z-index: 1
      +transition

    &.is-open
      #{$root}--description
        transform: translateY(-10px)
        visibility: visible
        opacity: 1

// object
.o-action
  &__userAvatar
    $button-size: 38px
    line-height: 1

    & &--item
      width: $button-size
      height: $button-size
      display: block
      overflow: hidden
      white-space: nowrap
      border: 1px solid $border-white
      border-radius: 50%
      +transition

      +mouseover
        border: 1px solid $border-light-orange

  &__userNavigation
    $root: &

    & &--item
      width: 100%
      line-height: 3.4
      display: block
      color: $font-xx-dark-gray
      font-size: $font-small
      text-align: left
      text-decoration: none
      white-space: nowrap
      padding: 0 1.1em

      +mouseover
        color: $font-dark-blue
        background-color: rgba($bg-xx-light-blue, 1)

.o-list
  &__userNavigation
    & &--item
      &.is-signout
        border-top: 1px solid $border-x-light-gray
</style>
